const i18n = {
  registerHeader: {
    1: "Зарегистрироваться",
    0: "Зарэгістравацца",
  },
  ecpBrowserErrMessage: {
    1: "Данный браузер не поддерживает работу с ЭЦП",
    0: "Дадзены браўзэр не падтрымлівае працу з ЭЛП",
  },
  ecpAddErrMessage: {
    1: "Ошибка прикрепления ЭЦП к аккаунту",
    0: "Памылка прымацавання ЭЛП да акаўнта",
  },
  ecpUnpErrMessage: {
    1: "УНП пользователя не совпадает с УНП на цифровом носителе",
    0: "УНП карыстальніка не супадае з УНП на лічбавым носьбіце",
  },
  ecpRegErrMessage: {
    1: "Ошибка регистрации. Для таких типов пользователя как 'Юридическое лицо РБ', 'Индивидуальный предприниматель РБ' и 'Представительство иностранной организации' прикрепление ЭЦП к аккаунту обязательно!",
    0: "Памылка рэгістрацыі. Для такіх тыпаў карыстальніка як 'Юрыдычная асоба РБ', 'Індывідуальны прадпрымальнік РБ' і 'Прадстаўніцтва замежнай арганізацыі' прымацаванне ЭЛП да акаўнта абавязкова!",
  },
  userType: {
    1: "Тип пользователя",
    0: "Тып карыстальніка",
  },
	userName: {
		1 : 'Имя пользователя (логин)',
		0 : 'Імя карыстальніка (лагін)'
	},
  userNameMessage: {
    1: "Проверьте корректность введенных данных. Поле заполняется латинскими символами и цифрами без пробелов.",
    0: "Праверце карэктнасць уведзеных дадзеных. Поле запаўняецца лацінскімі сімваламі і лічбамі без прабелаў.",
  },
  userNameLength: {
    1: "Длина поля 2-32 символов.",
    0: "Даўжыня поля 2-32 знакаў.",
  },
  passwordMessage: {
    1: "Пароль должен содержать минимум 8 символов, содержать латинские символы в верхнем и нижнем регистре, а также минимум один цифровой символ.",
    0: "Пароль павінен змяшчаць мінімум 8 сімвалаў, утрымліваць лацінскія сімвалы ў верхнім і ніжнім рэгістры, а таксама мінімум адзін лічбавы сімвал.",
  },
  confirmPassword: {
    1: "Подтверждение пароля",
    0: "Пацверджанне пароля",
  },
  passwordEquals: {
    1: "Пароли должны совпадать.",
    0: "Паролі павінны супадаць.",
  },
  ecpSign: {
    1: "Прикрепить ЭЦП",
    0: "Прымацаваць ЭЛП",
  },
  register: {
    1: "Зарегистрироваться",
    0: "Зарэгістравацца",
  },
  phoneNumberRegister: {
    1: "Номер телефона, указанный при регистрации",
    0: "Нумар тэлефона, пазначаны пры рэгістрацыі",
  },
  userAgreement: {
    1: ["Я принимаю условия", "пользовательского соглашения"],
    0: ["Я прымаю ўмовы", "карыстальніцкага пагаднення"],
  },
  userAgreementNotAccept: {
    1: ["Вы не приняли условия пользовательского соглашения"],
    0: ["Вы не прынялі ўмовы карыстальніцкага пагаднення"],
  },
  requiredField: {
    1: "Поле '${label}' обязательно для заполнения.",
    0: "Поле '${label}' абавязкова для запаўнення.",
  },
  confirmPasswordRequired: {
    1: "Поле 'Подтверждение пароля' обязательно для заполнения.",
    0: "Поле 'Пацверджанне пароля' абавязкова для запаўнення.",
  },
  incorrectEmail: {
    1: "Поле 'Email' заполненно некорректно.",
    0: "Поле 'Email' запоўнена некарэктна.",
  },
  belpochtaRegisterTitle: {
    1: "Вы первый раз авторизуетесь через сервер авторизации НПЭС. Пожалуйста, заполните недостающие поля и зарегистрируйте их в нашей системе.",
    0: "Вы першы раз аўтарызуецеся праз сервер аўтарызацыі НПЭС. Калі ласка, запоўніце адсутнічаюць поля і зарэгіструйце іх у нашай сістэме.",
  },
  userNameNotUnique: {
    1: "Пользователем с таким именем уже существует в системе",
    0: "Карыстальнікам з такім імем ужо існуе ў сістэме" 
  }
};

export default i18n;
